import { Box, styled } from '@mui/material';

export const FeeRow = styled(Box)(() => ({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	justifyContent: 'space-between',
}));
